import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addClient,
  getClients,
  getClient,
  editClient,
  deleteClient,
  getAllClients,
} from "../../store/actions/client_action";
import { SEARCH_TERMS } from "../enums/clients_enum";
// Get All Data
export const useAllClients = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.client);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteClient(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getClients({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getClients({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getClients({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleClient = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.client);
  useEffect(() => {
    dispatch(getClient(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateClient = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addClient(data));
  };
  return [addData];
};
export const useUpdateClient = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editClient(id, data));
  };
  return [updateData];
};

export const useSelectAllClient = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.client);
    useEffect(() => {
      dispatch(getAllClients());
    }, []);
    return [data];
  };          